var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNestedTx = function SvgNestedTx(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99666 0C4.78406 0 5.42237 0.64045 5.42237 1.43049V4.01005C5.42237 4.80009 4.78406 5.44054 3.99666 5.44054H1.42571C0.638312 5.44054 0 4.80009 0 4.01005V1.43049C0 0.64045 0.638312 0 1.42571 0H3.99666ZM3.8798 1.54774H1.54257V3.8928H3.8798V1.54774Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5743 8.55946C13.3617 8.55946 14 9.19991 14 9.98995V12.5695C14 13.3595 13.3617 14 12.5743 14H10.0033C9.21594 14 8.57763 13.3596 8.57763 12.5695V9.98995C8.57763 9.19991 9.21594 8.55946 10.0033 8.55946H12.5743ZM12.4574 10.1072H10.1202V12.4523H12.4574V10.1072Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86978 4.49079H3.41235V8.06488C3.45517 8.47668 3.63052 9.09522 4.00277 9.59644C4.36242 10.0807 4.90185 10.459 5.76127 10.459H9.3606V12.0067H5.76127C4.3489 12.0067 3.37498 11.3414 2.76585 10.5212C2.17908 9.73117 1.92953 8.80376 1.87288 8.17146L1.86978 8.13689V4.49079Z",
    fill: "currentColor"
  })));
};
export default SvgNestedTx;